import { useLocation } from "../lib/locationContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator
} from "./ui/dropdown-menu";
import { MapPin, ChevronDown } from "lucide-react";

const LocationDropdown = () => {
  const { location, setLocation, locations } = useLocation();
  const current = locations.find(l => l.slug === location);

  // Group by city
  const byCity = locations.reduce((acc, l) => {
    (acc[l.city] = acc[l.city] || []).push(l);
    return acc;
  }, {});

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary hover:bg-secondary/80 text-sm font-medium transition-colors max-w-[200px]"
          data-testid="location-dropdown-trigger"
        >
          <MapPin className="w-3.5 h-3.5 text-primary flex-shrink-0" />
          <span className="truncate">{current?.name || "Gading Serpong"}</span>
          <ChevronDown className="w-3.5 h-3.5 flex-shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 max-h-96 overflow-y-auto">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-muted-foreground">Pilih Lokasi</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {Object.entries(byCity).map(([city, locs]) => (
          <div key={city}>
            <div className="px-2 py-1 text-[10px] uppercase tracking-wider text-muted-foreground font-bold">{city}</div>
            {locs.map(l => (
              <DropdownMenuItem
                key={l.slug}
                onClick={() => setLocation(l.slug)}
                data-testid={`location-${l.slug}`}
                className={location === l.slug ? "bg-primary/10 text-primary font-semibold" : ""}
              >
                <MapPin className="w-3.5 h-3.5 mr-2 opacity-60" /> {l.name}
              </DropdownMenuItem>
            ))}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LocationDropdown;
